var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/**
 * Copyright 2019, SumUp Ltd.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { mapRowProps, mapCellProps } from '../../utils';
import TableRow from '../TableRow';
import TableHeader from '../TableHeader';
import TableCell from '../TableCell';
/**
 * TableBody for the Table component. The Table handles rendering it.
 */
const TableBody = ({ rows = [], condensed, rowHeaders = false, sortHover, onRowClick, }) => (_jsx("tbody", { children: rows.map((row, rowIndex) => {
        const _a = mapRowProps(row), { cells } = _a, props = __rest(_a, ["cells"]);
        return (_jsx(TableRow, Object.assign({ onClick: onRowClick ? () => onRowClick(rowIndex) : undefined }, props, { children: cells.map((cell, cellIndex) => rowHeaders && cellIndex === 0 ? (_jsx(TableHeader, Object.assign({ fixed: true, condensed: condensed, scope: "row", isHovered: sortHover === cellIndex, sortParams: { sortable: false } }, mapCellProps(cell)), `table-cell-${rowIndex}-${cellIndex}`)) : (_jsx(TableCell, Object.assign({ condensed: condensed, isHovered: sortHover === cellIndex }, mapCellProps(cell)), `table-cell-${rowIndex}-${cellIndex}`))) }), `table-row-${rowIndex}`));
    }) }));
export default TableBody;
